import React from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'
import Headline from '#components/a/Headline'
import Text from '#components/a/Text'
import ControlsGroup from '#components/m/ControlsGroup'
import Button from '#components/a/Button'
// import { ReportErrorButton } from '#components/m/ReportErrorButton'
import {useCurrentUserId} from '#hooks/store/useCurrentUserId'
import {useNavigate} from 'react-router-dom'

function ErrorModal({
  showModal,
  headline,
  text,
  buttonText,
  onButtonClick,
  navigateBackOnOkay,
  overlayClassName,
  contentModifier,
  modifier = 'error',
  error,
  appInsights,
}) {
  const {currentUserId} = useCurrentUserId()
  const navigate = useNavigate()

  const trackError = (appInsights, error) => {
    if (appInsights) {
      appInsights.trackException({
        exception: error,
        properties: {
          userId: currentUserId,
        },
      })
    }
  }

  if (error && ((error.status && error.status >= 500) || !error.status)) {
    trackError(appInsights, error)
  }

  const handleOkayAndGoBack = () => {
    onButtonClick()
    if (navigateBackOnOkay) {
      navigate(-1)
    }
  }

  return (
    <div className="modal__wrap">
      <ReactModal
        appElement={document.getElementById('azubiguide')}
        isOpen={showModal}
        shouldCloseOnOverlayClick
        className={`modal modal--${modifier}`}
        overlayClassName={`modal__overlay${overlayClassName ? ` modal__overlay--${overlayClassName}` : ''}`}>
        <div className={`modal__content${contentModifier ? ` modal__content--${contentModifier}` : ''}`}>
          {headline && <Headline modifier="article" importance={2} text={headline} />}
          {text && <Text text={text} />}
          <ControlsGroup>
            <Button text={buttonText} event={handleOkayAndGoBack} variant="secondary" />

            {/* ReportErrorButton is temporarily removed! */}
            {/* {hasValidError && appInsights && (
              <ReportErrorButton criticalError={error} appInsights={appInsights} />
            )} */}
          </ControlsGroup>
        </div>
      </ReactModal>
    </div>
  )
}

ErrorModal.propTypes = {
  showModal: PropTypes.bool,
  headline: PropTypes.string,
  text: PropTypes.string,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func.isRequired,
  modifier: PropTypes.string,
  overlayClassName: PropTypes.string,
  contentModifier: PropTypes.string,
  error: PropTypes.object,
  appInsights: PropTypes.any,
  navigateBackOnOkay: PropTypes.bool,
}

export default ErrorModal
